export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0 w-full lg:w-80 aspect-[4/3] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20manga%20books%20scattered%20on%20a%20wooden%20table%2C%20warm%20candlelight%20ambiance%2C%20cherry%20blossom%20branch%20in%20a%20vase%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20peaceful%20atmosphere%2C%20editorial%20photography%20style%2C%20cozy%20and%20inviting&width=800&height=600&seq=about-manga-07&orientation=landscape"
              alt="关于樱花漫画网"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-6">
              关于樱花漫画网
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                樱花漫画网成立于2020年，是一家专注于提供<strong>全集漫画免费完整版下拉式在线阅读</strong>的优质平台。我们致力于为广大漫画爱好者打造一个内容全面、体验流畅的一站式漫画阅读空间。
              </p>
              <p>
                平台聚合了超过20000部<strong>全本漫画</strong>资源，覆盖韩漫、日漫、国漫三大板块，涵盖热血、恋爱、悬疑、奇幻、都市、校园、古风、科幻、惊悚等全部题材类型。无论您偏好哪种风格，都能在这里找到<strong>好看的漫画</strong>。
              </p>
              <p>
                樱花漫画网坚持"免费、完整、流畅"的核心理念，所有<strong>漫画全集</strong>均采用下拉式阅读模式，无需翻页等待，带来极致的沉浸式阅读体验。每日同步更新热门连载，让您不错过任何一部精彩作品。
              </p>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-2 h-2 bg-primary-500 rounded-full"></span>
                20000+ 全本漫画
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-2 h-2 bg-accent-500 rounded-full"></span>
                每日同步更新
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-2 h-2 bg-secondary-500 rounded-full"></span>
                全部免费阅读
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}